import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Services from '../components/Services';
import Work from '../components/Work';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import { motion } from 'framer-motion';
import { CheckCircle, Zap, Shield, BarChart, ArrowRight, Users, Globe, Award, Heart, Mail, Phone, MapPin } from 'lucide-react';

const Home = ({ onOpenForm }) => {
  const stats = [
    { label: "Projects Delivered", value: "150+", icon: <CheckCircle /> },
    { label: "Active Clients", value: "40+", icon: <Users /> },
    { label: "Team Experts", value: "25+", icon: <Award /> },
    { label: "Global Reach", value: "12 Countries", icon: <Globe /> }
  ];

  const values = [
    { title: "Innovation", icon: <Zap /> },
    { title: "Reliability", icon: <Shield /> },
    { title: "User-Centric", icon: <Heart /> }
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="home-page"
    >
      <Hero onOpenForm={onOpenForm} />
      <Marquee />
      
      <section className="why-choose-us">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Why Work With <span>Us</span></h2>
            <p className="section-subtitle">We don't just build software; we engineer business solutions.</p>
          </div>
          <div className="wcu-grid">
            {['Rapid Delivery', 'Security First', 'Data Driven', 'Quality Assured'].map((item, i) => (
              <div key={i} className="wcu-card">
                <div className="wcu-icon">
                  {i === 0 && <Zap />}
                  {i === 1 && <Shield />}
                  {i === 2 && <BarChart />}
                  {i === 3 && <CheckCircle />}
                </div>
                <h3>{item}</h3>
                <p>Ensuring excellence at every stage of the development lifecycle.</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Services />
      <Work />

      <section className="about-preview-home">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">About <span>Amavix</span></h2>
            <p className="section-subtitle">A collective of engineers dedicated to digital excellence.</p>
          </div>
          <div className="about-home-grid">
            <div className="ah-text">
              <h3>Engineering the Digital Future</h3>
              <p>Amavix Tech is a product-focused software studio. We partner with ambitious startups to build scalable platforms, AI solutions, and high-performance systems.</p>
              <div className="ah-values">
                {values.map((v, i) => (
                  <div key={i} className="ah-value-item">
                    {v.icon} <span>{v.title}</span>
                  </div>
                ))}
              </div>
              <Link to="/about" className="explore-link">Learn More About Us <ArrowRight size={18} /></Link>
            </div>
            <div className="ah-image">
              <div className="stats-grid-compact">
                {stats.slice(0, 2).map((stat, i) => (
                  <div key={i} className="stat-card-mini">
                    <div className="sh-value">{stat.value}</div>
                    <div className="sh-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tech-stack-section">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Our <span>Tech Stack</span></h2>
          </div>
          <div className="tech-logos">
            {['React', 'Next.js', 'Node.js', 'Python', 'OpenAI', 'AWS', 'Docker', 'PostgreSQL', 'TypeScript', 'Tailwind'].map((tech, i) => (
              <motion.div 
                key={tech} 
                className="tech-pill"
                whileHover={{ scale: 1.1, backgroundColor: 'rgba(var(--accent-primary-rgb), 0.1)', color: 'var(--accent-primary)' }}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
              >
                {tech}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Process />
      <Testimonials />
      <FAQ />

      <section className="home-contact-section">
        <div className="container">
          <div className="contact-grid-home">
            <div className="ch-info">
              <h2 className="section-title">Get in <span>Touch</span></h2>
              <p>Ready to build something amazing? Let's discuss your next project.</p>
              <div className="ch-details">
                <div className="ch-item"><Mail /> hello@amavix.tech</div>
                <div className="ch-item"><Phone /> +1 (555) 000-0000</div>
                <div className="ch-item"><MapPin /> San Francisco, CA</div>
              </div>
            </div>
            <div className="ch-form-preview">
              <div className="glass-form-preview" onClick={onOpenForm}>
                <h3>Launch Your Project</h3>
                <p>Fill out our quick inquiry form to get started.</p>
                <button className="btn btn-primary w-full">Start Inquiry <ArrowRight size={18} /></button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Home;
